import React, { useCallback, useEffect, useState } from "react";
import Table from "../Table";
import { GetExpense } from "../../redux/Transaction/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import NoData from "../noData";
import useInfiniteScroll from "../Hooks/useInfiniteScroll";
import { Tooltip } from "antd";

const DashboardExpenseTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [hasMoreData, setHasMoreData] = useState(true);

  const tableData = useSelector((state) => state?.Sale?.expenseData?.data);

  const tableHeading = {
    no: <div className="ml-5 text-center w-10">No.</div>,
    date: <div className="text-center w-28">Date</div>,
    vatAmount: <div className="text-center w-28">VAT Amount</div>,
    title: <div className="w-44 px-2">Title</div>,
    description: <div className="w-96 px-2">Description</div>,
    paymentMethod: <div className="text-center w-36">Payment Method</div>,
    status: <div className=" text-center w-20 mr-5">Status</div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = tableData?.map((e, index) => {
    return {
      no: <div className="ml-5 text-center w-10">{index + 1}</div>,
      date: (
        <div className="text-center w-28">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      vatAmount: <div className="text-center w-28">{e?.vatamount}</div>,
      title: <div className="w-44 px-2">{e?.title}</div>,
      description: (
        <Tooltip
          color="white"
          arrow={false}
          placement="bottomLeft"
          title={e?.description}
          overlayInnerStyle={{ color: "black" }}
        >
          <div className="w-80 text-ellipsis line-clamp-1">
            {e?.description.length > 30
              ? `${e?.description.slice(0, 30)}...`
              : e?.description}
          </div>
        </Tooltip>
      ),
      paymentMethod: (
        <div className="text-center w-36">
          {e?.paymentmethod?.paymentmethod}
        </div>
      ),
      status: (
        <div
          className={`${
            e?.status ? "text-green bg-green/10" : "text-textyellow bg-bgyellow"
          } mr-5 text-xs font-normal rounded px-1.5 py-2 w-20 flex items-center justify-center`}
        >
          {e?.status ? "Approved" : "Pending"}
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(GetExpense({ page: filter?.page, limit: filter?.limit })).then(
      (res) => {
        if (res?.data?.status === 401) {
          navigate("/");
        }
        if (res?.data?.data?.length === 0) {
          setHasMoreData(false);
        }
      }
    );
  }, [dispatch, navigate, filter]);

  return (
    <>
      {tableData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
    </>
  );
};

export default DashboardExpenseTable;
